<div class="testimonials-wrapper" @fade>
  <div class="entry" *ngFor="let testimonial of testimonials">
    <p class="info">"{{ testimonial.entry }}"</p>
    <p class="name">- {{ testimonial.name }}</p>
  </div>
</div>
